import {
    TrafficShareWithVisits,
    DefaultCellRightAlign,
    UrlCellWebsiteAnalysis,
    DefaultCell,
} from "app/components/React/Table/cells";
import { ChangeStateCell } from "app/components/React/Table/cells/ChangeStateCell";
import { SearchKeywordCellWithAutoCreate } from "app/components/React/Table/cells/SearchKeywordCellWithAutoCreate";
import { NO_DATA_SIGN, THRESHOLD_FOR_KEYWORD_RESEARCH_PERCENTAGE } from "app/filters/const";
import { translate } from "app/filters/i18nFilter";
import {
    abbrNumberFilter,
    capitalizeFirstLetterFilter,
    i18nTemplateFilter,
    roundNumberFilter,
} from "app/filters/ngFilters";
import { EKeywordTabs } from "app/UtilitiesAndConstants/Constants/SourceTypes";

import {
    TABLE_COLUMN_CLICKS_CHANGE,
    TABLE_COLUMN_KEYWORD,
    TABLE_COLUMN_SHARE,
    TABLE_COLUMN_VOLUME,
    TABLE_COLUMN_WINDOW_VOLUME,
    TABLE_COLUMN_TOP_URL,
    TABLE_COLUMN_CLICKS,
} from "../const";

export const getColumns = (
    isWindow: boolean,
    visibleColumns: string[],
    TotalCount?: number,
    onKeywordClick?: (val: string) => void,
    durationTooltipParams?: {
        currentMonth: string;
        lastMonth: string;
    },
) =>
    [
        {
            dataIndex: TABLE_COLUMN_KEYWORD,
            tooltipSubtitle: translate("website.keywords.2.0.table.keyword.column.tooltip"),
            title: `${translate("keywords.by.website.table.columns.keyword.title")} ${
                TotalCount ? `(${roundNumberFilter()(TotalCount)})` : ""
            }`,
            maxWidth: 250,
            minWidth: 120,
            render: (props) => (
                <SearchKeywordCellWithAutoCreate
                    {...props}
                    value={props}
                    onItemClick={onKeywordClick}
                    destinationState={"organicsearch_keywordAnalysis_2"}
                    destinationStateParams={{
                        selectedPageTab: capitalizeFirstLetterFilter()(EKeywordTabs[EKeywordTabs.Organic]),
                    }}
                />
            ),
        },
        {
            dataIndex: TABLE_COLUMN_TOP_URL,
            title: translate("website.seo.overview.table.url.column"),
            tooltipSubtitle: translate("website.seo.overview.table.url.column.tooltip"),
            minWidth: 150,
            maxWidth: 240,
            render: (rowCellData) => (
                <UrlCellWebsiteAnalysis
                    value={rowCellData}
                    {...rowCellData}
                />
            ),
        },
        {
            dataIndex: TABLE_COLUMN_SHARE,
            title: translate("keywords.by.website.table.columns.clicks.title"),
            tooltipSubtitle: translate("website.keywords.2.0.table.clicks.column.tooltip"),
            render: (value, record) => {
                const row = {
                    ...record,
                    totalVisitsRowProp: "Clicks",
                    thresholdForTotalFilter: 50,
                    thresholdTrafficShareWithVisitsPercentage: THRESHOLD_FOR_KEYWORD_RESEARCH_PERCENTAGE,
                };
                return (
                    <TrafficShareWithVisits
                        {...record}
                        value={value}
                        row={row}
                        applyAbbrNumberFilter
                        totalVisitsRowProp="Clicks"
                        thresholdForTotalFilter={50}
                        thresholdTrafficShareWithVisitsPercentage={THRESHOLD_FOR_KEYWORD_RESEARCH_PERCENTAGE}
                    />
                );
            },
            minWidth: 130,
            maxWidth: 217,
        },
        {
            dataIndex: TABLE_COLUMN_CLICKS_CHANGE,
            title: translate("analysis.source.search.all.table.columns.change.title"),
            tooltipSubtitle: i18nTemplateFilter()(
                "website.keywords.2.0.table.change.column.tooltip",
                durationTooltipParams,
            ),
            align: "right",
            render: (props) => {
                // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
                const { change } = props;
                const absChange = Math.abs(change);
                const precision = absChange > 0 && absChange < 0.1 ? 1 : 0;
                return (
                    <ChangeStateCell
                        {...props}
                        value={props}
                        undefinedSign={NO_DATA_SIGN}
                        isPercentage={true}
                        cellFilter={`simplePercentage:${precision}`}
                    />
                );
            },
            width: 74,
        },
        ...(isWindow
            ? [
                  {
                      dataIndex: TABLE_COLUMN_WINDOW_VOLUME,
                      title: translate("website.keywords.2.0.table.window.volume.column"),
                      tooltipSubtitle: translate("website.keywords.2.0.table.window.volume.column.tooltip"),
                      width: 78,
                      align: "right",
                      render: (rowCellData) => (
                          <DefaultCellRightAlign
                              value={abbrNumberFilter()(rowCellData)}
                              {...rowCellData}
                          />
                      ),
                  },
              ]
            : [
                  {
                      dataIndex: TABLE_COLUMN_VOLUME,
                      title: translate("website.keywords.2.0.table.monthly.volume.column"),
                      tooltipSubtitle: translate("website.keywords.2.0.table.monthly.volume.column.tooltip"),
                      width: 78,
                      align: "right",
                      render: (rowCellData) => (
                          <DefaultCellRightAlign
                              // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
                              value={abbrNumberFilter()(rowCellData)}
                              {...rowCellData}
                          />
                      ),
                  },
              ]),
        {
            dataIndex: TABLE_COLUMN_CLICKS,
            title: translate("organic.landing.pages.table.columns.keywordsNum.title"),
            tooltipSubtitle: translate(
                isWindow
                    ? "organic.landing.pages.2.0.table.window.keywords.column.tooltip"
                    : "organic.landing.pages.2.0.table.keywords.column.tooltip",
            ),
            width: 78,
            align: "right",
            render: (value, row) => {
                // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
                return <DefaultCell value={abbrNumberFilter()(row?.KeywordsCount)} />;
            },
        },
    ].filter((col) => visibleColumns.includes(col.dataIndex) || !col.dataIndex);
